import {useState} from "react";

export const useSelectedProduct = (initialState = {}) => {
    const [ selectedProduct, setSelectedProduct ] = useState(initialState);
    const setProduct = (e) => {
        setSelectedProduct(e);
    };
    const deSelect = () => {
        setSelectedProduct({});
    };
    return { selectedProduct, setProduct, deSelect };
};
